import types from 'actions/types'
import Immutable from 'seamless-immutable'
import {combineReducers} from 'redux'

export const message = (state = null, action) => {
  switch (action.type) {
    case types.SNACKBAR_MESSAGE:
      return action.message || state
    case types.SNACKBAR_CLEAR:
      return null
    default:
      return state
  }
}

export const icon = (state = null, action) => {
  switch (action.type) {
    case types.SNACKBAR_MESSAGE:
      return action.icon || null
    case types.SNACKBAR_CLEAR:
      return null
    default:
      return state
  }
}

export const autoHide = (state = Immutable(true), action) => {
  switch (action.type) {
    case types.SNACKBAR_MESSAGE:
      return action.autoHide
    default:
      return state
  }
}

export const allowClose = (state = Immutable(true), action) => {
  switch (action.type) {
    case types.SNACKBAR_MESSAGE: {
      if (action.allowClose != null) return action.allowClose
      return true
    }
    default:
      return state
  }
}

export default combineReducers({
  message,
  icon,
  autoHide,
  allowClose,
})
